// extracted by mini-css-extract-plugin
module.exports = {"item":"SoftSkills_item__cDEA8","text":"SoftSkills_text__38NxT"};